import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=3c911fce&scoped=true"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"
import style0 from "./actions.vue?vue&type=style&index=0&id=3c911fce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c911fce",
  null
  
)

export default component.exports